/* ===== THEME.JS — Main JavaScript ===== */

(function() {
  'use strict';

  /* ===== CART DRAWER ===== */
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  const cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      if (cartOverlay) cartOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      if (cartOverlay) cartOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  cartToggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (cartDrawer && cartDrawer.classList.contains('active')) {
        closeCartDrawer();
      } else {
        openCartDrawer();
      }
    });
  });

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function(el) {
      el.textContent = count;
    });
  }

  /* ===== CART AJAX ===== */
  function fetchCart() {
    return fetch(window.routes.cart_url + '.js', {
      headers: { 'Content-Type': 'application/json' }
    }).then(function(r) { return r.json(); });
  }

  function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      return fetchCart();
    })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      refreshCartDrawer();
      openCartDrawer();
    });
  }

  function changeCartItem(line, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      refreshCartDrawer();
    });
  }

  function refreshCartDrawer() {
    fetch(window.location.pathname, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('[data-cart-drawer]');
      if (newDrawer && cartDrawer) {
        cartDrawer.innerHTML = newDrawer.innerHTML;
        bindCartEvents();
      }
    });
  }

  function bindCartEvents() {
    // Close button
    var closeBtn = cartDrawer.querySelector('[data-cart-toggle]');
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);

    // Quantity buttons
    cartDrawer.querySelectorAll('[data-cart-quantity-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var line = parseInt(this.getAttribute('data-line'));
        var input = cartDrawer.querySelector('[data-cart-quantity-input][data-line="' + line + '"]');
        var qty = parseInt(input.value) + 1;
        changeCartItem(line, qty);
      });
    });

    cartDrawer.querySelectorAll('[data-cart-quantity-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var line = parseInt(this.getAttribute('data-line'));
        var input = cartDrawer.querySelector('[data-cart-quantity-input][data-line="' + line + '"]');
        var qty = Math.max(1, parseInt(input.value) - 1);
        changeCartItem(line, qty);
      });
    });

    // Remove buttons
    cartDrawer.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var line = parseInt(this.getAttribute('data-line'));
        changeCartItem(line, 0);
      });
    });
  }

  bindCartEvents();

  /* ===== QUICK ADD (Product Cards) ===== */
  document.addEventListener('click', function(e) {
    var quickAddBtn = e.target.closest('[data-quick-add]');
    if (!quickAddBtn) return;
    e.preventDefault();
    var variantId = quickAddBtn.getAttribute('data-product-id');
    if (variantId) {
      quickAddBtn.textContent = 'Adding...';
      quickAddBtn.disabled = true;
      addToCart(parseInt(variantId), 1).then(function() {
        quickAddBtn.textContent = 'Added!';
        setTimeout(function() {
          quickAddBtn.textContent = 'Add to Cart';
          quickAddBtn.disabled = false;
        }, 1500);
      });
    }
  });

  /* ===== PRODUCT PAGE: Variant Selection ===== */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var productJson = document.querySelector('[data-product-json]');
    var productData = productJson ? JSON.parse(productJson.textContent) : null;

    if (productData) {
      var selectedOptions = [];
      productData.options.forEach(function(_, i) {
        var optionEl = productForm.querySelector('[data-option-index="' + i + '"]');
        if (optionEl) {
          var activeBtn = optionEl.querySelector('.active');
          selectedOptions[i] = activeBtn ? activeBtn.getAttribute('data-option-value') : '';
        }
      });

      // Option buttons
      productForm.querySelectorAll('[data-option-value]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var parent = this.closest('[data-option-index]');
          var index = parseInt(parent.getAttribute('data-option-index'));

          parent.querySelectorAll('[data-option-value]').forEach(function(b) { b.classList.remove('active'); });
          this.classList.add('active');

          selectedOptions[index] = this.getAttribute('data-option-value');

          // Update label
          var label = parent.previousElementSibling;
          if (label) {
            var valueSpan = label.querySelector('[data-option-value]');
            if (valueSpan) valueSpan.textContent = selectedOptions[index];
          }

          // Find matching variant
          var matchedVariant = productData.variants.find(function(v) {
            return v.options.every(function(opt, i) {
              return opt === selectedOptions[i];
            });
          });

          if (matchedVariant) {
            var variantInput = productForm.querySelector('[data-variant-id]');
            if (variantInput) variantInput.value = matchedVariant.id;

            // Update price
            var addBtn = productForm.querySelector('[data-add-to-cart]');
            if (addBtn) {
              if (matchedVariant.available) {
                addBtn.disabled = false;
                addBtn.innerHTML = 'Add to Cart &mdash; ' + formatMoney(matchedVariant.price);
              } else {
                addBtn.disabled = true;
                addBtn.textContent = 'Sold Out';
              }
            }
          }
        });
      });

      // Product form submit
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var variantId = productForm.querySelector('[data-variant-id]').value;
        var qty = parseInt(productForm.querySelector('[data-quantity-input]').value) || 1;
        var addBtn = productForm.querySelector('[data-add-to-cart]');
        addBtn.textContent = 'Adding...';
        addBtn.disabled = true;
        addToCart(parseInt(variantId), qty).then(function() {
          addBtn.innerHTML = 'Added to Cart!';
          setTimeout(function() {
            addBtn.innerHTML = 'Add to Cart &mdash; ' + formatMoney(productData.variants.find(function(v) { return v.id == variantId; }).price);
            addBtn.disabled = false;
          }, 2000);
        });
      });
    }
  }

  /* ===== PRODUCT PAGE: Thumbnails ===== */
  document.querySelectorAll('[data-thumb-index]').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var imageUrl = this.getAttribute('data-image-url');
      var mainImg = document.getElementById('product-main-image');
      if (mainImg && imageUrl) {
        mainImg.src = imageUrl;
      }
      document.querySelectorAll('[data-thumb-index]').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* ===== PRODUCT PAGE: Quantity ===== */
  document.querySelectorAll('[data-quantity-plus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('[data-quantity-input]');
      input.value = parseInt(input.value) + 1;
    });
  });
  document.querySelectorAll('[data-quantity-minus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('[data-quantity-input]');
      input.value = Math.max(1, parseInt(input.value) - 1);
    });
  });

  /* ===== MOBILE MENU ===== */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileMenuToggles = document.querySelectorAll('[data-mobile-menu-toggle]');

  mobileMenuToggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (mobileMenu) {
        mobileMenu.classList.toggle('active');
        document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
      }
    });
  });

  // Mobile submenu expand
  document.querySelectorAll('.mobile-nav__expand').forEach(function(btn) {
    btn.addEventListener('click', function() {
      this.classList.toggle('active');
      var submenu = this.nextElementSibling;
      if (submenu) submenu.classList.toggle('active');
    });
  });

  /* ===== SEARCH OVERLAY ===== */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchToggles = document.querySelectorAll('[data-search-toggle]');

  searchToggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (searchOverlay) {
        searchOverlay.classList.toggle('active');
        if (searchOverlay.classList.contains('active')) {
          searchOverlay.querySelector('input').focus();
        }
      }
    });
  });

  /* ===== COLLECTION: Sort ===== */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ===== COLLECTION: Mobile filter toggle ===== */
  var filtersPanel = document.querySelector('[data-filters]');
  var filtersToggle = document.querySelector('[data-filters-toggle]');
  var filtersClose = document.querySelector('[data-filters-close]');

  if (filtersToggle && filtersPanel) {
    filtersToggle.addEventListener('click', function() {
      filtersPanel.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }
  if (filtersClose && filtersPanel) {
    filtersClose.addEventListener('click', function() {
      filtersPanel.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  /* ===== UTILITY ===== */
  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(2);
  }

})();
